import { createRoot } from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { IonReactRouter } from "@ionic/react-router";
import { IonRouterOutlet } from "@ionic/react";
import { SnackbarProvider } from "notistack";
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ horizontal: "center", vertical: "top" }}>
    <IonReactRouter>
      <IonRouterOutlet>
        <App />
      </IonRouterOutlet>
    </IonReactRouter>
  </SnackbarProvider>
);
